import Logger from 'src/core/utils/Logger'

import { WebSocketClient } from '../ws/WebSocketClient'

class WebSocketStore {
  private wsObjects: {
    [propName: string]: { [propName: string]: WebSocketClient }
  } = {}

  public add = (ws: WebSocketClient, id: string) => {
    if (this.wsObjects[id]) {
      Logger.error(`Websocket with id: '${id}' already added! Check another connection!`)
    }
    this.wsObjects[id] = { default: ws }
  }

  public get = (id: string, key?: string): WebSocketClient => {
    const currentWS = this.wsObjects[id][key || 'default']
    if (!currentWS && key) {
      this.wsObjects[id][key] = this.wsObjects[id]['default']
      return this.wsObjects[id][key]
    }
    return currentWS || this.wsObjects[id]['default']
  }

  public has = (id: string): boolean => {
    return !!this.wsObjects[id]
  }
}

export default new WebSocketStore()
